import { Typography } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import React from "react";
import { useIntl } from "react-intl";

export function RoleDescription() {
  const intl = useIntl();

  return (
    <Typography className="add-user-modal__role-tooltip">
      <Paragraph>
        {intl.formatMessage({ id: "jmix-store.role-description.admin" })}
      </Paragraph>
      <Paragraph>
        {intl.formatMessage({ id: "jmix-store.role-description.worker" })}
      </Paragraph>
      {/*<Paragraph>*/}
      {/*  Manager sees all keys in the subscription in company profile. May not have a key assigned.*/}
      {/*</Paragraph>*/}
    </Typography>
  );
}
